import Book from "app/models/book";
import request from "../request";

export const getBooks = () => {
  return request.get<Array<Book>>("/currency/book");
};
